const initAnnouncementCounter = (startDate, endDate, title) => {
	const MINS_IN_HOUR = 60;
	const SECONDS_IN_MIN = 60;
	const MILLISECONDS_IN_SECOND = 1000;
	const validateDatesFormat = (dates) => {
		const formatRegexp = /\d\d\d\d-\d\d-\d\d \d\d:\d\d/gm;
		const isCorrectFormat = dates.filter((date) => formatRegexp.test(date)).length > 0;
		return isCorrectFormat;
	};

	const validateDates = (year, month, day, hours, minutes) => {
		let isCorrect = true;
		if (year < 0) isCorrect = false;
		if (month < 0 || month > 12) isCorrect = false;
		if (day < 0 || day > 31) isCorrect = false;
		if (hours < 0 || hours > 24) isCorrect = false;
		if (minutes < 0 || minutes > 60) isCorrect = false;
		return isCorrect;
	};

	const transformStringToDate = (dateString) => {
		const [daysString, hoursString] = dateString.split(" ");
		const [year, month, day] = daysString.split("-");
		const [hours, minutes] = hoursString.split(":");
		if (!validateDates(year, month, day, hours, minutes)) {
			console.log("COUNTER: Date is incorrect");
			return;
		}
		return new Date(year, month - 1, day, hours, minutes).getTime();
	};

	const updateDatetimeAttr = (date) => {
		const wrapper = document.querySelector(".counter__time");
		if (!wrapper) return;
		wrapper.setAttribute("datetime", date);
	};

	const updateUI = (hours, minutes, seconds) => {
		const timePlaceholders = document.querySelectorAll(".counter__time--bar .counter__time-digit");
		if (!timePlaceholders.length) {
			console.log("COUNTER: There is no elements with .counter__time-digit class");
			return;
		}
		if (![3, 6].includes(timePlaceholders.length)) {
			console.log("COUNTER: There is not enough elements for hours, minutes and seconds");
			return;
		}

		const formattedHours = hours === 0 ? "00" : `${hours}`.length === 1 ? `0${hours}` : `${hours}`;
		const formattedMinutes = minutes === 0 ? "00" : `${minutes}`.length === 1 ? `0${minutes}` : `${minutes}`;
		const formattedSeconds = seconds === 0 ? "00" : `${seconds}`.length === 1 ? `0${seconds}` : `${seconds}`;
		const [hoursWrapper, minutesWrapper, secondsWrapper] = timePlaceholders;

		if (timePlaceholders.length === 6) {
			const [, , , hoursWrapper2, minutesWrapper2, secondsWrapper2] = timePlaceholders;

			if (hoursWrapper2.innerText !== formattedHours) {
				hoursWrapper2.innerText = formattedHours;
			}
			if (minutesWrapper2.innerText !== formattedMinutes) {
				minutesWrapper2.innerText = formattedMinutes;
			}
			if (secondsWrapper2.innerText !== formattedSeconds) {
				secondsWrapper2.innerText = formattedSeconds;
			}
		}

		if (hoursWrapper.innerText !== formattedHours) {
			hoursWrapper.innerText = formattedHours;
		}
		if (minutesWrapper.innerText !== formattedMinutes) {
			minutesWrapper.innerText = formattedMinutes;
		}
		if (secondsWrapper.innerText !== formattedSeconds) {
			secondsWrapper.innerText = formattedSeconds;
		}
	};

	const appendToDOM = () => {
		const counterWrapper = document.querySelector("#counter-announcement-bar");
		if (!counterWrapper) {
			console.log("COUNTER: There is no counter wrapper in DOM");
			return;
		}

		counterWrapper.innerHTML = `
		<span class="counter__label">${title}</span>
		<time class="counter__time counter__time--bar">
			<span class="counter__time-digit"></span>
			<span class="counter__time-divider">:</span>
			<span class="counter__time-digit"></span>
			<span class="counter__time-divider">:</span>
			<span class="counter__time-digit"></span>
		</time>
		`;
	};

	if (!validateDatesFormat([startDate, endDate])) {
		console.log(`COUNTER: Dates format is incorrect`);
		return;
	}
	const startTime = transformStringToDate(startDate);
	const endTime = transformStringToDate(endDate);

	if (endTime <= startTime) {
		console.log("COUNTER: End time can not be lower than start time");
		return;
	}

	const nowCheck = new Date().getTime();
	if (nowCheck <= startTime || nowCheck >= endTime) {
		console.log("COUNTER: There is no counter to start");
		return;
	}
	appendToDOM();
	updateDatetimeAttr(endDate);

	const interval = setInterval(() => {
		const now = new Date().getTime();
		const distance = endTime - now;
		const hoursLeft = Math.floor(distance / MILLISECONDS_IN_SECOND / SECONDS_IN_MIN / MINS_IN_HOUR);
		const minutesLeft = Math.floor(
			(distance % (MILLISECONDS_IN_SECOND * SECONDS_IN_MIN * MINS_IN_HOUR)) / (MILLISECONDS_IN_SECOND * SECONDS_IN_MIN)
		);
		const secondsLeft = Math.floor((distance % (MILLISECONDS_IN_SECOND * SECONDS_IN_MIN)) / MILLISECONDS_IN_SECOND);

		updateUI(hoursLeft, minutesLeft, secondsLeft);

		if (distance < 0) {
			clearInterval(interval);
		}
	}, 1000);
};
